import { Modal } from "bootstrap";

export function initSessionStopModal() {
  const modal = document.getElementById("session-stop-modal");
  if (!modal) return;
  const confirm = modal.querySelector("[data-session-stop-confirm]");
  let form = null;

  modal.addEventListener("show.bs.modal", (event) => {
    const trigger = event.relatedTarget;
    form = trigger?.closest("form") ?? null;
    confirm.disabled = !form;
    modal.querySelector("[data-session-stop-label]").textContent =
      trigger?.dataset.sessionLabel ?? "";
  });

  confirm.addEventListener("click", () => {
    if (!form?.isConnected) return;
    confirm.disabled = true;
    if (!form.hasAttribute("hx-post")) {
      document.body.dataset.sessionStopPending = "true";
    }
    form.requestSubmit();
    Modal.getOrCreateInstance(modal).hide();
  });

  modal.addEventListener("hidden.bs.modal", () => {
    form = null;
  });
}
